"use client";

import { c as _c } from "react/compiler-runtime";
import { Calendar04Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { parseDate } from "chrono-node/en";
import * as React from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
function formatDate(date: Date | undefined) {
  if (!date) {
    return "";
  }
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
}
export function NaturalLanguageDatePicker(t0) {
  const $ = _c(30);
  const {
    label,
    endMonth,
    onChangeAction
  } = t0;
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("In 1 week");
  let t1;
  if ($[0] !== value) {
    t1 = parseDate(value) || undefined;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [date, setDate] = React.useState(t1);
  const [month, setMonth] = React.useState(date);
  let t2;
  if ($[2] !== label) {
    t2 = <Label htmlFor="date" className="text-lg font-bold md:text-2xl">{label}</Label>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onChangeAction) {
    t3 = e => {
      setValue(e.target.value);
      const date_0 = parseDate(e.target.value);
      if (date_0) {
        setDate(date_0);
        setMonth(date_0);
        onChangeAction(date_0);
      }
    };
    $[4] = onChangeAction;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_0 => {
      if (e_0.key === "ArrowDown") {
        e_0.preventDefault();
        setOpen(true);
      }
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== value) {
    t5 = <Input id="date" value={value} placeholder="Tomorrow or next week" className="bg-background pr-10" onChange={t3} onKeyDown={t4} />;
    $[7] = t3;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <PopoverTrigger asChild={true}><Button id="date-picker" variant="ghost" className="absolute top-1/2 right-2 size-6 -translate-y-1/2"><HugeiconsIcon icon={Calendar04Icon} className="size-3.5" /><span className="sr-only">Select date</span></Button></PopoverTrigger>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = date_1 => {
      setDate(date_1);
      setValue(formatDate(date_1));
      setOpen(false);
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== date || $[13] !== endMonth || $[14] !== month) {
    t8 = <PopoverContent className="w-auto overflow-hidden p-0" align="end"><Calendar mode="single" selected={date} captionLayout="dropdown" month={month} endMonth={endMonth} onMonthChange={setMonth} onSelect={t7} /></PopoverContent>;
    $[12] = date;
    $[13] = endMonth;
    $[14] = month;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== open || $[17] !== t8) {
    t9 = <Popover open={open} onOpenChange={setOpen}>{t6}{t8}</Popover>;
    $[16] = open;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t9) {
    t10 = <div className="relative flex gap-2 max-w-xs">{t5}{t9}</div>;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== date) {
    t11 = formatDate(date);
    $[22] = date;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <div className="text-muted-foreground text-sm">Project will be completed by{" "}<span className="font-medium">{t11}</span>.</div>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== t2) {
    t13 = <div className="flex flex-col gap-4">{t2}{t10}{t12}</div>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t2;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}